/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { signOut } from 'firebase/auth';
import Loader from '../../Utils/Loader';
import Messages from '../../Utils/Messages';
import { auth } from '../../Services/FirebaseService';
import ApiService from '../../Services/ApiService';
import { BrandContent, useTailwindBrand } from '../../Components/shared';
import {
    ENV_VERIFIED_TRAINER,
    getActivePrestataireBrandConfig,
    getActivePrestationBrandConfig,
    isBrandActive,
} from '../../config/environment.config';
import OnboardingLandingPage from '../../Screens/Client/Aici/OnboardingLandingPage';
import {
    userFirebaseUnSetAccountAction,
    userTeachrUnSetAccountAction,
    userUnSetCurrentProfile,
    userUnSetLoad,
} from '../../Redux/Actions/UserActions';
import {
    resetActiveCourseAction,
    resetInfoChartAction,
    resetNextCourseAction,
    resetPastCourseAction,
} from '../../Redux/Actions/PunctualCourseActions';
import { useAiciOnboarding } from '../../Hooks/useAiciOnboarding';
import { AiciOnboardingProvider } from '../../Contexts/AiciOnboardingContexte';
import { AiciStep } from '../../Hooks/InterfaceAiciOnboarding';
import OnboardingStepper from './OnboardingStepper';
import PersonalInfoStep from './Steps/PersonalInfoStep';
import BirthBankStep from './Steps/BirthBankStep';
import AddressStep from './Steps/AddressStep';
import RecapStep from './Steps/RecapStep';
import ConfirmationStep from './Steps/ConfirmationStep';

const STEPPER_LABELS = [
    'Vos informations',
    'Naissance & banque',
    'Votre adresse',
    'Récapitulatif',
    'Confirmation',
];

const Index = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const { classes, common } = useTailwindBrand();
    const currentUser = useSelector((state: any) => state?.user?.currentUser);

    const aici = useAiciOnboarding(params.key);
    const { teachr, teachrFirstName, currentStep, serverStep, goToStep, loading } = aici;
    const [hasSeenLanding, setHasSeenLanding] = useState(false);

    // Page d'accroche affichée au tout début (contact jamais commencé), si le prof a un scoop
    // et hors marque Verified Trainer reprend la condition de l'ancien parcours.
    const showLanding =
        serverStep === 0 &&
        !hasSeenLanding &&
        !!teachr?.scoop &&
        !isBrandActive(ENV_VERIFIED_TRAINER);

    // Un parcours client ne doit pas tourner sous une session professeur : on déconnecte.
    useEffect(() => {
        if (currentUser?.isTeachr) {
            signOut(auth)
                .then(() => {
                    ApiService.disableAuth();
                    dispatch({ type: 'DELETE_TEACHR_INFO' });
                    dispatch(userTeachrUnSetAccountAction());
                    dispatch(userFirebaseUnSetAccountAction());
                    dispatch(resetActiveCourseAction());
                    dispatch(resetPastCourseAction());
                    dispatch(resetNextCourseAction());
                    dispatch(resetInfoChartAction());
                    dispatch(userUnSetCurrentProfile());
                    dispatch(userUnSetLoad());
                })
                .catch((error) => console.error(error));
        }
    }, [currentUser, dispatch]);

    const renderStepScreen = () => {
        switch (currentStep) {
            case AiciStep.PersonalInfo: return <PersonalInfoStep />;
            case AiciStep.BirthBank: return <BirthBankStep />;
            case AiciStep.Address: return <AddressStep />;
            case AiciStep.Recap: return <RecapStep />;
            case AiciStep.Confirmation: return <ConfirmationStep />;
            default: return <PersonalInfoStep />;
        }
    };

    if (!loading && showLanding) {
        return (
            <OnboardingLandingPage
                profFirstName={teachr?.firstName}
                profLastName={teachr?.lastName}
                onStart={() => setHasSeenLanding(true)}
            />
        );
    }

    return (
        <AiciOnboardingProvider value={aici}>
            <Loader />
            <Messages />
            <div className={`${classes.background} min-h-screen overflow-auto`}>
                <div className="w-full max-w-6xl px-4 py-6 mx-auto lg:px-8 lg:py-10">
                    {/* En-tête */}
                    <header className="mb-6">
                        <BrandContent
                            tag="h1"
                            children={
                                <>
                                    Bénéficiez de l'Avance Immédiate de Crédit d'Impôt pour vos {getActivePrestationBrandConfig('s')}
                                    {teachrFirstName && (
                                        <> avec <span className="capitalize">{teachrFirstName}</span></>
                                    )}
                                </>
                            }
                            type="homeSubtitle"
                            className={`${common.subtitle} ${classes.primaryText}`}
                        />
                        {teachrFirstName && (
                            <p className={`mt-2 ${common.body} ${classes.text}`}>
                                Votre {getActivePrestataireBrandConfig()}{' '}
                                <span className="font-bold capitalize">{teachrFirstName}</span>{' '}
                                vous demande de compléter ce formulaire afin de pouvoir déclarer vos{' '}
                                {getActivePrestationBrandConfig('s')} auprès de l'URSSAF.
                            </p>
                        )}
                    </header>

                    {/* Corps : stepper + étape courante */}
                    <div className="flex flex-col gap-4 lg:flex-row">
                        <aside className="p-4 bg-white border border-gray-200 shadow-sm rounded-xl lg:w-1/4 lg:order-last h-max">
                            <OnboardingStepper
                                steps={STEPPER_LABELS}
                                activeStep={currentStep}
                                onStepClick={currentStep < AiciStep.Confirmation ? goToStep : undefined}
                            />
                        </aside>
                        <main className="p-4 bg-white border border-gray-200 shadow-sm rounded-xl lg:w-3/4 lg:p-8">
                            {!loading && renderStepScreen()}
                        </main>
                    </div>
                </div>
            </div>
        </AiciOnboardingProvider>
    );
};

export default Index;
